<div class="responsive-card">
  <div class="responsive-card-title mb-4" i18n>Deposits</div>
  <app-review-deposit-details-deposit-card
    [bankAccount]="bankAccount"
    [isWrittenCheque]="isMandatoryRetirement || !bankAccount" />
</div>
